// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteProcurementMethodModel {
    'procurementMethodTypeId'?: number;
    'procurementMethodTypeCd'?: string;
    'procurementMethodTypeDesc'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteProcurementMethodModel>> = [
        {
            "name":     "procurementMethodTypeId",
            "baseName": "procurementMethodTypeId",
            "type":     "number"
        },
        {
            "name":     "procurementMethodTypeCd",
            "baseName": "procurementMethodTypeCd",
            "type":     "string"
        },
        {
            "name":     "procurementMethodTypeDesc",
            "baseName": "procurementMethodTypeDesc",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SiteProcurementMethodModel.attributeTypeMap;
    }
}
